export default __webpack_public_path__ + "static/media/failed.cad953ad.svg";